







































































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    Pagination,
    Loading,
    ArrowRightIcon,
    TrashCanOutlineIcon,
    CloseIcon,
    Header,
  },

  data() {
    return {
      currentPage: 0,
      loaded: true,
      searchListName: '',
      searchingListByName: false,
    };
  },

  computed: {
    ...mapState({
      lists: (state: any) => state.lists.lists,
      boards: (state: any) => state.boards.boards,
    }),
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/listas`);
    }

    await this.changePage(this.currentPage);
  },

  methods: {
    removeList: async function(listId: number, index: number) {
      if (
        confirm(
          'Tem certeza que deseja deletar essa lista? Ela não poderá ser recuperada!',
        )
      ) {
        let response = await this.$store.dispatch('REMOVE_LIST', listId);

        if (response === true) {
          this.$store.commit('REMOVE_LIST', index);
        } else {
          //TODO analyze the error
          alert('Essa lista não pode ser deletada!');
        }
      }
    },

    removeFromBoard: async function(materialId: number) {
      if (confirm('Tem certeza que deseja remover essa lista desse mural?')) {
        await this.$store.dispatch('REMOVE_MATERIAL', materialId);
        let currentPage = this.currentPage;
        let searchListName = this.searchListName;
        await this.$store.dispatch('PULL_LISTS', {
          currentPage,
          searchListName,
        });
      }
    },

    changePage: async function(event: any) {
      this.currentPage = event;
      this.loaded = false;
      let currentPage = this.currentPage;
      let searchListName = this.searchListName;
      await this.$store.dispatch('PULL_LISTS', { currentPage, searchListName });
      this.loaded = true;
      this.$router.push(`/listas/${this.currentPage + 1}`);
    },

    searchListByName: async function() {
      if (this.searchListName.length > 0) {
        this.currentPage = 0;
        this.$router.replace(`/listas`);
        let searchListName = this.searchListName;
        this.searchingListByName = true;
        await this.$store.dispatch('PULL_LISTS', {
          searchListName,
          currentPage: this.currentPage,
        });
        this.searchingListByName = false;
      }
    },
  },
});
